<template>
    <el-row class="ns-paginate-header">
        <el-col
            :sm="24"
            :md="10"
            class="title"
            :class="{'dark-theme': dark}"
        >
            {{ tableTitle }}
        </el-col>
        <el-col
            :sm="24"
            :md="14"
            class="ns-paginate-header-container"
        >
            <div class="custom-searchbar" slot="custom-searchbar">+</div>
            <div class="ns-paginate-search-input">
                <el-input
                    v-if="displaySearchBar"
                    ref="searchInput"
                    v-model="searchValue"
                    :placeholder="getVerbose('ns_paginate_search_placeholder')"
                    class="searchbar"
                    @submit="triggerSearch"
                >
                    <i slot="append" class="ti-search" @click="triggerSearch"></i>
                </el-input>
            </div>
            <dropdown-with-selector
                ref="dropdownSelector"
                :items="dropdownItems"
                :dark="dark"
                @triggerDisplayChange="triggerDisplayChange"
            ></dropdown-with-selector>
        </el-col>
    </el-row>
</template>

<script>

import {mapGetters} from 'vuex';
import moment from 'moment';
import dropdownWithSelector from '../dropdownWithSelector/index.vue';

export default {

    components: {
        dropdownWithSelector
    },

    props: {
        tableTitle: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        modelName: {
            type: String,
            required: true
        },
        displayFiltersButton: {
            type: Boolean,
            required: true
        },
        displayCsvButton: {
            type: Boolean,
            required: true
        },
        displaySearchBar: {
            type: Boolean,
            required: true
        },
        dark: {
            type: Boolean,
            required: true
        },
        listFieldToDisplay: {
            type: Array,
            required: true
        }
    },

    data: function(){
        return {
            searchValue: '',
            searchTimeoutId: '',
            csvIsLoading: false,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
        dropdownItems() {
            let items = [
                {
                    name: 'Refresh data',
                    iconClass: 'ti-reload',
                    callback: this.reload
                },
            ];
            if (this.displayFiltersButton) {
                items.push({
                    name: 'Filter data',
                    iconClass: 'ti-filter',
                    callback: this.toggleFilters
                });
            }
            if (this.displayCsvButton) {
                items.push({
                    name: this.getVerbose('ns_paginate_csv_button'),
                    iconClass: 'ti-download',
                    callback: this.downloadCsv
                });
            }
            // TODO rendre le display des colonnes manageable dans une prochaine mr
            // items.push({
            //         name: 'Hide colums',
            //         iconClass: 'ti-angle-left',
            //         selection: selection
            // });
            return items;
        },
        // exmeple of content for the "hide column" selector
        // selection() {
        //     // a remplacer par la liste des colonnes
        //     return [
        //         {
        //             name: 'test',
        //             selected: false
        //         }
        //     ];
        // }
    },

    watch: {
        searchValue(val) {
            clearTimeout(this.searchTimeoutId);
            let timeout = 2000;
            if(val === null || val === ''){
                // en cas de clear on veut que le chargement des données soit instantané
                timeout = 1;
            }
            this.searchTimeoutId = setTimeout(this.triggerSearch, timeout);
        }
    },

    mounted: function(){
        if(this.$route.query.search){
            this.searchValue = this.$route.query.search;
        }
        if(this.$refs.searchInput){
            this.$refs.searchInput.$el.addEventListener('keydown', this.eventSearch);
        }
    },
    beforeDestroy: function(){
        if(this.$refs.searchInput){
            this.$refs.searchInput.$el.removeEventListener('keydown', this.eventSearch);
        }
    },

    methods: {
        eventSearch(event) {
            if (event.keyCode === 13) { // keycode 13 = "Enter"
                this.triggerSearch();
            }
        },
        triggerDisplayChange() {
            // todo : remonter la liste des colonnes a cacher au composant parent
        },
        downloadCsv (){
            let url = typeof this.url === 'string' ? this.url : this.url();
            url = url.split('?');
            url.splice(1, 0, 'export/?');
            url = url.join('');

            this.csvIsLoading = true;
            this.$store.axios.get(`${url}`).then((response) => {
                this.csvIsLoading = false;
                let blob = new Blob(["\ufeff", response.data]);
                let url = URL.createObjectURL(blob);

                let link = document.createElement("a");
                link.style = 'display: none';
                link.href = url;
                link.download = `export-${moment().format('YYYY-MM-DD-HH-mm')}-${this.modelName}.csv`;
                document.body.appendChild(link); // Required for FF
                link.click(); // This will download the data file named "my_data.csv".
                this.$refs.dropdownSelector.visible = false;
            }).catch((e) => {
                this.csvIsLoading = false;
            });
        },
        triggerSearch() {
            this.$emit('triggerSearch', this.searchValue);
        },
        toggleFilters() {
            this.$emit('toggleFilters');
            this.$refs.dropdownSelector.visible = false;
        },
        reload() {
            this.$emit('reload');
            this.$refs.dropdownSelector.visible = false;
        }
    },
};
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/-new-ns-paginate-header.vue